import { defineStore } from "pinia";
import { useModelStore } from "@/store/model/model";
import { useStorage } from "@vueuse/core";
import { getUser, login } from "@/api/auth";
import { LoginRequest, LoginResponse } from "@/interface/auth";
import { message } from "ant-design-vue";
import { useTrainingStore } from "@/store/training/training";
import { useAchievementStore } from "@/store/achievement";
import { addLearningLog } from "@/api/learning";
import { LOG_TYPE } from "@/interface/learning";

export const useUserInfoStore = defineStore("userInfo", {
  state: () => {
    return {
      hasLogged: false,
      username: "",
      userId: -1,
      access: useStorage("access", ""),
      refresh: useStorage("refresh", ""),
      loginMethod: useStorage("method", ""),
    };
  },
  actions: {
    async init() {
      if (this.access !== "") {
        getUser().then((res) => {
          addLearningLog({ log_type: LOG_TYPE.login, log: {} });

          const data = res.data[0];
          this.username = data.username;
          this.userId = data.id;

          const modelStore = useModelStore();
          modelStore.getUserSavedModel();

          const trainingStore = useTrainingStore();
          trainingStore.getUserTrainingHistory();

          const achievementStore = useAchievementStore();
          achievementStore.getUserAchievements();

          message.success("Welcome Back, " + this.username);
        });
      }
    },
    async loginWithUsername(loginReq: LoginRequest) {
      await login(loginReq).then((res) => {
        const data: LoginResponse = res.data;
        this.username = loginReq.username;
        this.access = data.access;
        this.refresh = data.refresh;
      });
      this.loginMethod = "username";
      await this.init();
    },
    logout() {
      this.clearUserInfo();

      switch (this.loginMethod) {
        case "oidc": {
          this.loginMethod = "";
          location.href = `/disconnect/${this.loginMethod}/`;
          break;
        }
        case "username": {
          this.loginMethod = "";
          location.reload();
          break;
        }
        default: {
          message.error("unexpected loginMethod: " + this.loginMethod).then();
        }
      }
    },
    clearUserInfo() {
      this.username = "";
      this.access = "";
      this.refresh = "";
    },
  },
});
